import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
    casingCollapse: boolean;
    linerCollapse: boolean;
    tubingCollapse: boolean;
    protectorListCollapse: boolean;
    protectorCalculationsCollapse: boolean;
    oilContractionsCollapse: boolean;
    selectedProtectorListCollapse: boolean;
    cableClearingCollapse: boolean;
    surfaceVoltageCollapse: boolean;
    accessoriesAboveEspCollapse: boolean;
    espEquipmentCollapse: boolean;
    accessoriesBelowEspCollapse: boolean;
    miscellaneousCollapse: boolean;
    setDepthSummaryCollapse: boolean;
    recommnendedParametersCollapse: boolean;
    surfaceEquipmentCollapse: boolean;
    controllerCollapse: boolean;
    transformersCollapse: boolean;
    harmonicFilterCollapse: boolean;
    performanceCurvesCollapse: boolean;
    surfaceConditionsCollapse: boolean;
    iprTypeCollapse: boolean;
    settingDepthCollapse: boolean;
    fluidCollapse: boolean;
    oilPropertyCollapse: boolean;
    gasPropertyCollapse: boolean;
    gasVolumeCollapse: boolean;
    othersCollapse: boolean;
    correlationCollapse: boolean;
    powerConditionsCollapse: boolean;
    gasImpuritiesCollapse: boolean;
    problemsCollapse: boolean;
    othersTabCollapse: boolean;
    notesCollapse: boolean;
    summaryCollapse: boolean;
    gasSeparatorCollapse: boolean;
    gasHandlerCollapse: boolean;
    addChargePumpCollapse: boolean;
    chargePump1Collapse: boolean;
    chargePump2Collapse: boolean;
    chargePump3Collapse: boolean;
    projectSummaryCollapse: boolean;
    pumpCalculationsCollapse: boolean;
    pumpListCollapse: boolean;
    pumpBOHCollapse: boolean;
    performanceCurvesPumpCollapse: boolean;
    maximumPressureCollapse: boolean;
    compositePumpPerformanceCurvesCollapse: boolean;
    pumpIterationCollapse: boolean;
    wellInflowCalculationsCollapse: boolean;
    wellIprCalculationsCollapse: boolean;
    tdhCalculationsCollapse: boolean;
    motorListCollapse: boolean;
    selectedMotorListCollapse: boolean;
    motorPerformanceCollapse: boolean;
    fluidVelocityCollapse: boolean;
    sensorCollapse: boolean;
    recommnendedParametersMotorCollapse: boolean;
    motorCalculationsCollapse: boolean,
    motorPerformmanceDataCollapse: boolean,
    motorRatingCollapse: boolean,
    fluidVelocityCheckCollapse: boolean,
    gasFormulasCollapse: boolean,
    gasHandlersCollapse: boolean,
    gasChargePumpCollapse: boolean,
    basicWIFCollapse: boolean,
    basicIPRCollapse: boolean,
    basicTDHCollapse: boolean,
    pumpCollapse: boolean
    protectorCollapse: boolean,
    oilContractionCollapse: boolean
    cableCleavoltCollapse: boolean,
    surfaceVoltCollapse: boolean
    baseLineCollapse: boolean,
    wappertwoCollapse: boolean,
    wapperHarmonicFilterCollapse: boolean
}

export const initialState: State = {
    protectorListCollapse: true,
    protectorCalculationsCollapse: true,
    oilContractionsCollapse: true,
    selectedProtectorListCollapse: true,
    casingCollapse: true,
    linerCollapse: false,
    tubingCollapse: true,
    cableClearingCollapse: true,
    surfaceVoltageCollapse: true,
    accessoriesAboveEspCollapse: true,
    espEquipmentCollapse: true,
    accessoriesBelowEspCollapse: true,
    miscellaneousCollapse: true,
    setDepthSummaryCollapse: true,
    recommnendedParametersCollapse: true,
    surfaceEquipmentCollapse: true,
    controllerCollapse: true,
    transformersCollapse: true,
    harmonicFilterCollapse: true,
    performanceCurvesCollapse: true,
    surfaceConditionsCollapse: true,
    iprTypeCollapse: true,
    settingDepthCollapse: true,
    fluidCollapse: true,
    oilPropertyCollapse: true,
    gasPropertyCollapse: true,
    gasVolumeCollapse: true,
    othersCollapse: true,
    correlationCollapse: true,
    powerConditionsCollapse: true,
    gasImpuritiesCollapse: true,
    problemsCollapse: true,
    othersTabCollapse: true,
    notesCollapse: true,
    summaryCollapse: true,
    gasSeparatorCollapse: true,
    gasHandlerCollapse: true,
    addChargePumpCollapse: true,
    chargePump1Collapse: true,
    chargePump2Collapse: true,
    chargePump3Collapse: true,
    projectSummaryCollapse: true,
    pumpCalculationsCollapse: true,
    pumpListCollapse: false,
    pumpBOHCollapse: false,
    performanceCurvesPumpCollapse: true,
    maximumPressureCollapse: true,
    compositePumpPerformanceCurvesCollapse: true,
    pumpIterationCollapse: false,
    wellInflowCalculationsCollapse: true,
    wellIprCalculationsCollapse: false,
    tdhCalculationsCollapse: true,
    motorListCollapse: true,
    selectedMotorListCollapse: true,
    motorPerformanceCollapse: true,
    fluidVelocityCollapse: true,
    sensorCollapse: true,
    recommnendedParametersMotorCollapse: true,
    motorCalculationsCollapse: true,
    motorPerformmanceDataCollapse: true,
    motorRatingCollapse: true,
    fluidVelocityCheckCollapse: true,
    gasFormulasCollapse: true,
    gasHandlersCollapse: true,
    gasChargePumpCollapse: true,
    basicWIFCollapse: true,
    basicIPRCollapse: true,
    basicTDHCollapse: true,
    pumpCollapse: true,
    protectorCollapse: true,
    oilContractionCollapse: true,
    cableCleavoltCollapse: true,
    surfaceVoltCollapse: true,
    baseLineCollapse: true,
    wappertwoCollapse: true,
    wapperHarmonicFilterCollapse: true
};

const CollapseSlice = createSlice({
    name: "collapse",
    initialState,
    reducers: {
        setGasFormulasCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasFormulasCollapse = action.payload;
        },
        setGasHandlersCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasHandlersCollapse = action.payload;
        },
        setGasChargePumpCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasChargePumpCollapse = action.payload;
        },
        setMotorCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.motorCalculationsCollapse = action.payload;
        },
        setMotorPerformmanceDataCollapse: (state, action: PayloadAction<boolean>) => {
            state.motorPerformmanceDataCollapse = action.payload;
        },
        setMotorRatingCollapse: (state, action: PayloadAction<boolean>) => {
            state.motorRatingCollapse = action.payload;
        },
        setFluidVelocityCheckCollapse: (state, action: PayloadAction<boolean>) => {
            state.fluidVelocityCheckCollapse = action.payload;
        },
        setBasicWIFCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicWIFCollapse = action.payload;
        },
        setBasicIPRCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicIPRCollapse = action.payload;
        },
        setBasicTDHCollapse: (state, action: PayloadAction<boolean>) => {
            state.basicTDHCollapse = action.payload;
        },
        setPumpCollapse: (state, action: PayloadAction<boolean>) => {
            state.pumpCollapse = action.payload;
        },
        setOilContractionCollapse: (state, action: PayloadAction<boolean>) => {
            state.oilContractionCollapse = action.payload;
        },
        setProtectorCollapse: (state, action: PayloadAction<boolean>) => {
            state.protectorCollapse = action.payload;
        },
        setCableCleavoltCollapse: (state, action: PayloadAction<boolean>) => {
            state.cableCleavoltCollapse = action.payload;
        },
        setSurfaceVoltCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceVoltCollapse = action.payload;
        },
        setBaseLineCollapse: (state, action: PayloadAction<boolean>) => {
            state.baseLineCollapse = action.payload;
        },
        setWappertwoCollapse: (state, action: PayloadAction<boolean>) => {
            state.wappertwoCollapse = action.payload;
        },
        setWapperHarmonicFilterCollapse: (state, action: PayloadAction<boolean>) => {
            state.wapperHarmonicFilterCollapse = action.payload;
        },
        setProtectorListCollapse: (state, action: PayloadAction<boolean>) => {
            state.protectorListCollapse = action.payload;
        },
        setProtectorCalculationsCollapse: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.protectorCalculationsCollapse = action.payload;
        },
        setOilContractionsCollapse: (state, action: PayloadAction<boolean>) => {
            state.oilContractionsCollapse = action.payload;
        },
        setSelectedProtectorListCollapse: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.selectedProtectorListCollapse = action.payload;
        },
        setCasingCollapse: (state, action: PayloadAction<boolean>) => {
            state.casingCollapse = action.payload;
        },
        setLinerCollapse: (state, action: PayloadAction<boolean>) => {
            state.linerCollapse = action.payload;
        },
        setTubingCollapse: (state, action: PayloadAction<boolean>) => {
            state.tubingCollapse = action.payload;
        },
        setCableClearingCollapse: (state, action: PayloadAction<boolean>) => {
            state.cableClearingCollapse = action.payload;
        },
        setSurfaceVoltageCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceVoltageCollapse = action.payload;
        },
        setAccessoriesAboveEspCollapse: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.accessoriesAboveEspCollapse = action.payload;
        },
        setEspEquipmentCollapse: (state, action: PayloadAction<boolean>) => {
            state.espEquipmentCollapse = action.payload;
        },
        setAccessoriesBelowEspCollapse: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.accessoriesBelowEspCollapse = action.payload;
        },
        setMiscellaneousCollapse: (state, action: PayloadAction<boolean>) => {
            state.miscellaneousCollapse = action.payload;
        },
        setSetDepthSummaryCollapse: (state, action: PayloadAction<boolean>) => {
            state.setDepthSummaryCollapse = action.payload;
        },
        setRecommendedParametersCollapse: (state, action: PayloadAction<boolean>) => {
            state.recommnendedParametersCollapse = action.payload;
        },
        setSurfaceEquipmentCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceEquipmentCollapse = action.payload;
        },
        setControllerCollapse: (state, action: PayloadAction<boolean>) => {
            state.controllerCollapse = action.payload;
        },
        setTransformersCollapse: (state, action: PayloadAction<boolean>) => {
            state.transformersCollapse = action.payload;
        },
        setHarmonicFilterCollapse: (state, action: PayloadAction<boolean>) => {
            state.harmonicFilterCollapse = action.payload;
        },
        setPerformanceCurvesCollapse: (state, action: PayloadAction<boolean>) => {
            state.performanceCurvesCollapse = action.payload;
        },
        setSurfaceConditionsCollapse: (state, action: PayloadAction<boolean>) => {
            state.surfaceConditionsCollapse = action.payload;
        },
        setIprTypeCollapse: (state, action: PayloadAction<boolean>) => {
            state.iprTypeCollapse = action.payload;
        },
        setSettingDepthCollapse: (state, action: PayloadAction<boolean>) => {
            state.settingDepthCollapse = action.payload;
        },
        setFluidCollapse: (state, action: PayloadAction<boolean>) => {
            state.fluidCollapse = action.payload;
        },
        setOilPropertyCollapse: (state, action: PayloadAction<boolean>) => {
            state.oilPropertyCollapse = action.payload;
        },
        setGasPropertyCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasPropertyCollapse = action.payload;
        },
        setGasVolumeCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasVolumeCollapse = action.payload;
        },
        setOthersCollapse: (state, action: PayloadAction<boolean>) => {
            state.othersCollapse = action.payload;
        },
        setCorrelationCollapse: (state, action: PayloadAction<boolean>) => {
            state.correlationCollapse = action.payload;
        },
        setPowerConditionsCollapse: (state, action: PayloadAction<boolean>) => {
            state.powerConditionsCollapse = action.payload;
        },
        setGasImpuritiesCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasImpuritiesCollapse = action.payload;
        },
        setProblemsCollapse: (state, action: PayloadAction<boolean>) => {
            state.problemsCollapse = action.payload;
        },
        setOthersTabCollapse: (state, action: PayloadAction<boolean>) => {
            state.othersTabCollapse = action.payload;
        },
        setNotesCollapse: (state, action: PayloadAction<boolean>) => {
            state.notesCollapse = action.payload;
        },
        setSummaryCollapse: (state, action: PayloadAction<boolean>) => {
            state.summaryCollapse = action.payload;
        },
        setGasSeparatorCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasSeparatorCollapse = action.payload;
        },
        setGasHandlerCollapse: (state, action: PayloadAction<boolean>) => {
            state.gasHandlerCollapse = action.payload;
        },
        setAddChargePumpCollapse: (state, action: PayloadAction<boolean>) => {
            state.addChargePumpCollapse = action.payload;
        },
        setChargePump1Collapse: (state, action: PayloadAction<boolean>) => {
            state.chargePump1Collapse = action.payload;
        },
        setChargePump2Collapse: (state, action: PayloadAction<boolean>) => {
            state.chargePump2Collapse = action.payload;
        },
        setChargePump3Collapse: (state, action: PayloadAction<boolean>) => {
            state.chargePump3Collapse = action.payload;
        },
        setProjectSummaryCollapse: (state, action: PayloadAction<boolean>) => {
            state.projectSummaryCollapse = action.payload;
        },
        setPumpCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.pumpCalculationsCollapse = action.payload;
        },
        setPumpListCollapse: (state, action: PayloadAction<boolean>) => {
            state.pumpListCollapse = action.payload;
        },
        setBOHCollapse: (state, action: PayloadAction<boolean>) => {
            state.pumpBOHCollapse = action.payload;
        },
        setPerformanceCurvesPumpCollapse: (state, action: PayloadAction<boolean>) => {
            state.performanceCurvesPumpCollapse = action.payload;
        },
        setMaximumPressureCollapse: (state, action: PayloadAction<boolean>) => {
            state.maximumPressureCollapse = action.payload;
        },
        setCompositePumpPerformanceCurvesCollapse: (state, action: PayloadAction<boolean>) => {
            state.compositePumpPerformanceCurvesCollapse = action.payload;
        },
        setPumpIterationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.pumpIterationCollapse = action.payload;
        },
        setWellInflowCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.wellInflowCalculationsCollapse = action.payload;
        },
        setWellIprCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.wellIprCalculationsCollapse = action.payload;
        },
        setTdhCalculationsCollapse: (state, action: PayloadAction<boolean>) => {
            state.tdhCalculationsCollapse = action.payload;
        },
        setMotorListCollapse: (state, action: PayloadAction<boolean>) => {
            state.motorListCollapse = action.payload;
        },
        setSelectedMotorListCollapse: (state, action: PayloadAction<boolean>) => {
            state.selectedMotorListCollapse = action.payload;
        },
        setMotorPerformanceCollapse: (state, action: PayloadAction<boolean>) => {
            state.motorPerformanceCollapse = action.payload;
        },
        setFluidVelocityCollapse: (state, action: PayloadAction<boolean>) => {
            state.fluidVelocityCollapse = action.payload;
        },
        setSensorCollapse: (state, action: PayloadAction<boolean>) => {
            state.sensorCollapse = action.payload;
        },
        setRecommendedParametersMotorCollapse: (state, action: PayloadAction<boolean>) => {
            state.recommnendedParametersMotorCollapse = action.payload;
        },
    },
});

export const {
    setProtectorListCollapse,
    setProtectorCalculationsCollapse,
    setOilContractionsCollapse,
    setSelectedProtectorListCollapse,
    setCasingCollapse,
    setLinerCollapse,
    setTubingCollapse,
    setCableClearingCollapse,
    setSurfaceVoltageCollapse,
    setAccessoriesAboveEspCollapse,
    setEspEquipmentCollapse,
    setAccessoriesBelowEspCollapse,
    setMiscellaneousCollapse,
    setSetDepthSummaryCollapse,
    setRecommendedParametersCollapse,
    setSurfaceEquipmentCollapse,
    setControllerCollapse,
    setTransformersCollapse,
    setHarmonicFilterCollapse,
    setPerformanceCurvesCollapse,
    setSurfaceConditionsCollapse,
    setIprTypeCollapse,
    setSettingDepthCollapse,
    setFluidCollapse,
    setOilPropertyCollapse,
    setGasPropertyCollapse,
    setGasVolumeCollapse,
    setOthersCollapse,
    setCorrelationCollapse,
    setPowerConditionsCollapse,
    setGasImpuritiesCollapse,
    setProblemsCollapse,
    setOthersTabCollapse,
    setNotesCollapse,
    setSummaryCollapse,
    setGasSeparatorCollapse,
    setGasHandlerCollapse,
    setAddChargePumpCollapse,
    setChargePump1Collapse,
    setChargePump2Collapse,
    setChargePump3Collapse,
    setProjectSummaryCollapse,
    setPumpCalculationsCollapse,
    setPumpListCollapse,
    setBOHCollapse,
    setPerformanceCurvesPumpCollapse,
    setMaximumPressureCollapse,
    setCompositePumpPerformanceCurvesCollapse,
    setPumpIterationsCollapse,
    setWellInflowCalculationsCollapse,
    setWellIprCalculationsCollapse,
    setTdhCalculationsCollapse,
    setMotorListCollapse,
    setSelectedMotorListCollapse,
    setMotorPerformanceCollapse,
    setFluidVelocityCollapse,
    setSensorCollapse,
    setRecommendedParametersMotorCollapse,
    setMotorCalculationsCollapse,
    setMotorPerformmanceDataCollapse,
    setMotorRatingCollapse,
    setFluidVelocityCheckCollapse,
    setGasFormulasCollapse,
    setGasHandlersCollapse,
    setGasChargePumpCollapse,
    setBasicWIFCollapse,
    setBasicIPRCollapse,
    setBasicTDHCollapse,
    setPumpCollapse,
    setOilContractionCollapse,
    setProtectorCollapse,
    setCableCleavoltCollapse,
    setSurfaceVoltCollapse,
    setBaseLineCollapse,
    setWapperHarmonicFilterCollapse,
    setWappertwoCollapse
} = CollapseSlice.actions;
export default CollapseSlice.reducer;
